﻿import { Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { INestedSet } from "@models/entity-models";
import { eRuleType } from "@models/enums";
import { Configurator } from "./configurator";

@Kbo(CToken.NestedSet)
export class NestedSet extends UiObject implements INestedSet {
    constructor(kom: KbObjectManager) {
        super(kom, { ruleType: eRuleType.nestedSetSelected });
    }

    public display: string;
    public autoNavigateToElement: boolean;
    
    private _configurators: Configurator[];
    @Enumerable()
    public get configurators(): Configurator[] {
        if (!this._configurators) this._configurators = [];
        return this._configurators;
    }
    public set configurators(val) {
        this._configurators = val;
    }
}
